import { stockService } from "Dashboard/scenes/Stock/services/stock.service";
import { forwardRef, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { IOption } from "Dashboard/domain/IOption";

const VehicleSelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { vehicleValue, setVehicleValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const vechiles = await stockService.getVehicles();
      const op = vechiles.map((vechile) => {
        return {
          label: vechile.registrationPlate,
          value: vechile.vehicleId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getValue = () => {
    if (vehicleValue) {
      return vehicleValue;
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setVehicleValue) {
      setVehicleValue(option);
    }
    setValueLocal(option);
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  const createOption = async (registrationPlate: string): Promise<IOption> => {
    try {
      const item = await stockService.createVehicle(registrationPlate);
      return {
        label: item.registrationPlate,
        value: item.vehicleId,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      // props.setValue("takenAwayByVehicleId", newOption.value, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      isClearable
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      formatCreateLabel={formatCreate}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput && inputValue}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(vehicleValue?.label))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      placeholder={""}
      isDisabled={isLoading}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default VehicleSelectCreate;
